import { useEffect, useState } from "react";
import DoctorAppointmentSlots from "./DoctorAppointmentSlots";
import { NoDoctorsContactForm } from "./NoDoctorsContactForm";

import { FaMapMarkerAlt } from "react-icons/fa";
import { MainContainer, SpecialityDesc, SubContainer } from "./Doctors.styles";
import Paper from "@mui/material/Paper";
import { RxCross2 } from "react-icons/rx";
import Doctor from "../images/doctorAvtar.png";
import {
  useParams,
  useNavigate,
  Link,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import NavigateNextSharpIcon from "@mui/icons-material/NavigateNextSharp";
import axios from "axios";

import { GetAllDoctorsService } from "../Services/TabServices";
import { isAppointmentslotOpen, setDoctorDetails } from "../reduxtool/action";
import { useDispatch, useSelector } from "react-redux";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { spec } from "node:test/reporters";
import { set } from "date-fns";

// Interfaces
interface Location {
  LocationId: number;
  LocationName: string;
  HospitalName: string;
  HospitalImage?: string;
}

interface SecondaryLocation {
  LocationId: number;
  LocationName: string;
  hospitalName: string;
}

interface DoctorLocation {
  locationId: number;
  locationName: string;
  hospitalName: string;
}

interface Language {
  LangId: number;
  Name: string;
  IsActive: boolean;
  CreatedOn: string | null;
  CreatedBy: string | null;
}

export default function Doctors() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentLocation  = useLocation();
   const { location: locationParam, specialization } = useParams<{
  location?: string;
  specialization?: string;
}>();
  // const { specialization } = useParams();
const isExplicitLocationRoute =
  currentLocation.pathname.startsWith("/doctors/location/");
  
const isLocationAndSpecializationRoute =
  Boolean(locationParam && specialization);

const shouldApplyLocationFromUrl =
  isExplicitLocationRoute || isLocationAndSpecializationRoute;

  const [allDoctors, setAllDoctors] = useState<any[]>([]);
  const [docAvlDays, setDocAvlDays] = useState([]);
  const [showSlotsDrawer, setShowSlotsDrawer] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);
  const [isLoading, setLoading] = useState(true);
  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);
  const [selectedFees, setSelectedFees] = useState<string[]>([]);
  const [filteredDoctors, setFilteredDoctors] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [locationsData, setLocationsData] = useState<Location[]>([]);
  const [languagesData, setLanguagesData] = useState<Language[]>([]);
  const gender = ["M", "F"];
  const [specialities, setSpecialities] = useState<any[]>([]);
  const [filters, setFilters] = useState({ speciality: "" });
  const [selectedDepartment, setSelectedDepartment] = useState<string>("");

  
  const [selectedGenders, setSelectedGenders] = useState<string[]>([]);
  const resultsPerPage = 30;
  const totalResults = filteredDoctors.length;
  const totalPages = Math.ceil(totalResults / resultsPerPage);
  const pageFromUrl = parseInt(searchParams.get("page") || "1", 10);
  const [currentPage, setCurrentPage] = useState(pageFromUrl);
  const [selectedExperiences, setSelectedExperiences] = useState<string[]>([]);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>([]);
  const [doctorSelectedLocations, setDoctorSelectedLocations] = useState<{
    [key: number]: DoctorLocation;
  }>({});
  const [selectedLocationId, setSelectedLocationId] = useState<number>(0);

  
const SPECIALIZATION_STORAGE_KEY = 'selectedSpecialization';

  const feeRanges = [
    { label: "Below 1000", value: "0-999" },
    { label: "Above 1000", value: "1000-" },
  ];

useEffect(() => {
  const handleResetFilters = () => {
   setSelectedLocations([]);
    setSelectedDepartment("");
    setSelectedGenders([]);
    setSelectedExperiences([]);
    setSelectedLanguages([]);
    setSearchTerm("");
    setFilters({ speciality: "" });
    setFilteredDoctors(allDoctors);
    setCurrentPage(1);
   
    // localStorage.removeItem("SPECIALIZATIONSTORAGEKEY");
  };
  window.addEventListener('resetDoctorsFilters', handleResetFilters);
  return () => window.removeEventListener('resetDoctorsFilters', handleResetFilters);
}, [allDoctors]);

  const experienceRanges = [
    { label: "0 - 5 years", value: "0-4" },
    { label: "5 - 10 years", value: "5-9" },
    { label: "10 - 15 years", value: "10-14" },
    { label: "15 - 20 years", value: "15-19" },
    { label: "20+ years", value: "20-" },
  ];
useEffect(() => {
  if (selectedLocations.length > 0 && locationsData.length > 0) {
    const matchedLocation = locationsData.find(loc => 
      loc.LocationName === selectedLocations[0]
    );
    setSelectedLocationId(matchedLocation?.LocationId || 0);
  }
}, [selectedLocations, locationsData]);


useEffect(() => {
  if (!shouldApplyLocationFromUrl || !locationParam || locationsData.length === 0) return;

  const match = locationsData.find(
    (loc) => normalizeSlug(loc.LocationName) === normalizeSlug(locationParam)
  );

  if (match) {
    setSelectedLocations([match.LocationName]);
    setSelectedLocationId(match.LocationId);
  } else {
    setSelectedLocations([]);
    setSelectedLocationId(0);
  }
}, [shouldApplyLocationFromUrl, locationParam, locationsData]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/locations`
        );
        if (response?.data) setLocationsData(response.data);
      } catch (error) {
        console.error("Failed to fetch locations:", error);
      }
    };
    fetchLocations();
  }, []);

  // ─── Fetch Languages ───────────────────────────────────────────────────────
  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/languages`
        );
        if (response?.data) {
          const activeLanguages = response.data
            .filter((lang: Language) => lang.IsActive)
            .sort((a: Language, b: Language) => a.Name.localeCompare(b.Name));
          setLanguagesData(activeLanguages);
        }
      } catch (error) {
        console.error("Failed to fetch languages:", error);
      }
    };
    fetchLanguages();
  }, []);

  // ─── Fetch Specialities ────────────────────────────────────────────────────
  // useEffect(() => {
  //   const fetchSpecialities = async () => {
  //     try {
  //       const response: any = await axios.get(
  //         `${process.env.REACT_APP_BASE_URL}/api/Patient/GetSpecialization`
  //       );
  //       if (response?.data) setSpecialities(response.data);
  //     } catch (error) {
  //       console.error("Failed to fetch specialities:", error);
  //     }
  //   };
  //   fetchSpecialities();
  // }, []);

   useEffect(() => {
    const fetchSpecialities = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Lookup/departments`,{
            params:{
  Remark:"Get the list of the departments",

  Event:"Get Departments"
            }
          }
        );
        if (response?.data) setSpecialities(response.data);
      } catch (error) {
        console.error("Failed to fetch specialities:", error);
      }
    };
    fetchSpecialities();
  }, []);

  // ─── Fetch ALL Doctors (single call, no speciality param) ─────────────────
  // useEffect(() => {
  //   const getData = async () => {
  //     try {
  //       setLoading(true);
  //       const res: any = await GetAllDoctorsService(); // ✅ Always fetch all doctors
  //       const sorted = res?.data?.sort(
  //         (a: any, b: any) => b.experienceYears - a.experienceYears
  //       );
  //       setAllDoctors(sorted || []);
  //     } catch (err) {
  //       console.error("Error fetching doctors", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   getData();
  // }, []); 
  // ─── Fetch ALL Doctors ─────────────────────────────────────────────────────
useEffect(() => {
  const getData = async () => {
    try {
      setLoading(true);
      const res: any = await GetAllDoctorsService();

      const slugify = (name: string) =>
        name?.toLowerCase().trim().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-") ?? "";
      const sorted = res?.data
        ?.map((doc: any) => ({
          ...doc,
          // ✅ Pre-compute slug from departmentName (or fallback to specialization)
          slugDepartment: slugify(doc.departmentName ||  ""),
        }))
        .sort((a: any, b: any) => b.experienceYears - a.experienceYears);

      setAllDoctors(sorted || []);
      console.log("Fetched doctors:", sorted);
    } catch (err) {
      console.error("Error fetching doctors", err);
    } finally {
      setLoading(false);
    }
  };
  getData();
}, []);


  // ─── Sync speciality filter from URL param ────────────────────────────────
  // useEffect(() => {
  //   if (specialization) {
  //     console.log("URL specialization param:", specialization);
  //     const decodedSpecialization = deslugify(specialization);
  //     console.log("Decoded specialization:", decodedSpecialization);
  //     setFilters({ speciality: decodedSpecialization });
  //   } else {
  //     console.log("No specialization in URL");
  //     setFilters({ speciality: "" });
  //   }
  // }, [specialization]);

//  useEffect(() => {
//     let selectedSpec = "";

//     if (selectedDepartment) {
//       selectedSpec = selectedDepartment;
//       console.log("Using selectedDepartment state:", selectedSpec);
//     } else if (specialization) {
//       selectedSpec = deslugify(specialization);
//       console.log("Using URL param specialization:", selectedSpec);
//     }

//     setFilters({ speciality: selectedSpec });
//   }, [selectedDepartment, specialization]);
// ─── Sync speciality filter from selectedDepartment state OR URL param ────
// useEffect(() => {
//   let selectedSpec = "";

//   if (selectedDepartment) {
//     // ✅ User picked from dropdown — use as-is (exact DepartmentName value)
//     selectedSpec = selectedDepartment;
//   } else if (specialization) {
//     // ✅ No dropdown selection — deslugify the URL param and use it
//     selectedSpec = deslugify(specialization);
//   }

//   setFilters({ speciality: selectedSpec });
// }, [selectedDepartment, specialization]);
// ─── Sync speciality filter from selectedDepartment OR URL param ──────────
useEffect(() => {
  if (selectedDepartment) {
    setFilters({ speciality: selectedDepartment });
  } else if (specialization) {
    setFilters({ speciality: specialization });
  } else {
    setFilters({ speciality: "" });
  }
}, [selectedDepartment, specialization]);

  // ─── Re-run filters whenever allDoctors or any filter state changes ────────
  useEffect(() => {
    applyFilters({
      locations: selectedLocations,
      fees: selectedFees,
      name: searchTerm,
      speciality: filters.speciality,
      genders: selectedGenders,
      experiences: selectedExperiences,
      languages: selectedLanguages,
    });
  }, [
    allDoctors,
    filters.speciality,
    selectedLocations,
    selectedFees,
    searchTerm,
    selectedGenders,
    selectedExperiences,
    selectedLanguages,
    specialization
  ]);

  // ─── Initialize doctor location selections ────────────────────────────────
  useEffect(() => {
    if (filteredDoctors.length > 0) {
      const initialLocations: { [key: number]: DoctorLocation } = {};
      filteredDoctors.forEach((doctor: any) => {
        const locations = getDoctorLocations(doctor);
        if (locations.length > 0 && !doctorSelectedLocations[doctor.doctorId]) {
          initialLocations[doctor.doctorId] = locations[0];
        }
      });
      if (Object.keys(initialLocations).length > 0) {
        setDoctorSelectedLocations((prev) => ({ ...prev, ...initialLocations }));
      }
    }
  }, [filteredDoctors]);

  // ─── Fetch Doctor Availability ────────────────────────────────────────────
  useEffect(() => {
    const fetchAvailability = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorAvailability`
        );
        setDocAvlDays(response.data);
      } catch (err) {
        console.error("Error fetching doctor availability:", err);
      }
    };
    fetchAvailability();
  }, []);

  // ─── Sync slots drawer to redux ───────────────────────────────────────────
  useEffect(() => {
    dispatch(isAppointmentslotOpen(showSlotsDrawer));
  }, [showSlotsDrawer, dispatch]);

  // ─── Pagination sync ──────────────────────────────────────────────────────
  useEffect(() => {
    setCurrentPage(pageFromUrl);
  }, [pageFromUrl]);

  useEffect(() => {
    const maxPage = Math.ceil(filteredDoctors.length / resultsPerPage);
    if (currentPage > maxPage && maxPage > 0) setCurrentPage(1);
  }, [filteredDoctors, currentPage]);

  // ─── Helpers ──────────────────────────────────────────────────────────────
  const getDoctorLocations = (doctor: any): DoctorLocation[] => {
    const locations: DoctorLocation[] = [];
    if (doctor.location) {
      locations.push({
        locationId: doctor.locationId || 0,
        locationName: doctor.location,
        hospitalName: doctor.hospitalName || doctor.location,
      });
    }
    if (doctor.secondaryLocations && Array.isArray(doctor.secondaryLocations)) {
      doctor.secondaryLocations.forEach((secLoc: SecondaryLocation) => {
        locations.push({
          locationId: secLoc.LocationId,
          locationName: secLoc.LocationName,
          hospitalName: secLoc.hospitalName,
        });
      });
    }
    return locations;
  };

  const handleLocationSelect = (doctorId: number, location: DoctorLocation) => {
    setDoctorSelectedLocations((prev) => ({ ...prev, [doctorId]: location }));
  };

  const deslugify = (slug: string | undefined | null) => {
    if (!slug) return "";
    return slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const normalizeSlug = (name: string): string => {
    return name
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s]/g, "")
      .replace(/\s+/g, "-");
  };
  const buildDoctorsUrl = (locationName?: string, departmentName?: string) => {
  const locationSlug = locationName ? normalizeSlug(locationName) : "";
  const departmentSlug = departmentName ? normalizeSlug(departmentName) : "";

  if (locationSlug && departmentSlug) {
    return `/doctors/${locationSlug}/${departmentSlug}`;
  }
  if (locationSlug) {
    return `/doctors/location/${locationSlug}`;
  }
  if (departmentSlug) {
    return `/doctors/${departmentSlug}`;
  }
  return `/doctors`;
};

  const trimWords = (text: string, count: number) => {
    const words = text.split(" ");
    return words.length > count ? words.slice(0, count).join(" ") + " ..." : text;
  };
  const toTitleCase = (str: string) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setSearchParams({ page: page.toString() });
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const getPageNumbers = () =>
    Array.from({ length: totalPages }, (_, i) => i + 1);

  const startResult = (currentPage - 1) * resultsPerPage + 1;
  const endResult = Math.min(currentPage * resultsPerPage, totalResults);

  const getAvailableDays = (doctorId: number) => {
    const doctorAvailability: any = docAvlDays.find(
      (doc: any) => doc.doctorId === doctorId
    );
    if (!doctorAvailability)
      return { availableDays: [], startDate: null, endDate: null };

    const dayShortcodes: { [key: string]: string } = {
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
      sunday: "Sun",
    };

    const availableDays = Object.entries(doctorAvailability)
      .filter(
        ([key, value]) =>
          ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].includes(key) &&
          value === "Available"
      )
      .map(([day]) => dayShortcodes[day]);

    return {
      availableDays,
      startDate: doctorAvailability.startDate,
      endDate: doctorAvailability.endDate,
    };
  };

  const handleCardClick = (doctorId: any, doctorInfo: any) => {
    setSelectedDoctor(doctorId);
    const { doctorData } = doctorInfo;
    if (!doctorData?.doctorName || !doctorData?.speciality || !doctorData?.location) return;

    const slugify = (name: string) =>
      name.toLowerCase().trim().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-");

    navigate(
      `/doctor/${slugify(doctorData.location)}/${slugify(doctorData.speciality)}/${slugify(doctorData.doctorName)}`,
      { state: { availableDays: doctorData.avlDays, doctorData, doctorId } }
    );
  };

  const handleBookAppointment = (doctorId: any) => {
    setSelectedDoctor(doctorId);
    dispatch(setDoctorDetails(doctorId));
    setShowSlotsDrawer(true);
  };
useEffect(() => {
  if (!specialization || specialities.length === 0) {
    setSelectedDepartment("");
    setFilters({ speciality: "" });
    return;
  }

  const match = specialities.find((dept: any) =>
    normalizeSlug(dept.DepartmentName) === specialization
  );

  if (match) {
    setSelectedDepartment(match.DepartmentName);
    setFilters({ speciality: match.DepartmentName });
  }
}, [specialization, specialities]);
  // ─── Core filter function (operates on allDoctors) ────────────────────────
  const applyFilters = ({
    locations,
    fees,
    name = searchTerm,
    speciality = filters.speciality,
    genders = selectedGenders,
    experiences = selectedExperiences,
    languages = selectedLanguages,
  }: {
    locations: string[];
    fees: string[];
    name?: string;
    speciality?: string;
    genders?: string[];
    experiences?: string[];
    languages?: string[];
  }) => {
    console.log("Applied filters called");
    const filtered = allDoctors.filter((doc: any) => {
      const matchesLocation =
        locations.length === 0 ||
        locations.some((loc) => {
          const trimmedLoc = loc.trim().toLowerCase();
          const primaryMatch = doc.location?.trim().toLowerCase() === trimmedLoc;
          const secondaryMatch = doc.secondaryLocations?.some(
            (secLoc: SecondaryLocation) =>
              secLoc.LocationName?.trim().toLowerCase() === trimmedLoc
          );
          return primaryMatch || secondaryMatch;
        });

      const matchesGender = genders.length === 0 || genders.includes(doc.gender);

      const matchesLanguages =
        languages.length === 0 ||
        languages.some((lang) => {
          if (!doc.languages) return false;
          const doctorLanguages = doc.languages
            .split(",")
            .map((l: string) => l.trim().toLowerCase());
          return doctorLanguages.includes(lang.toLowerCase());
        });

      const matchesName =
        name === "" || doc.doctorName.toLowerCase().includes(name.toLowerCase());

      // ✅ Speciality matched client-side on allDoctors
     // ✅ Case-insensitive match against departmentName, specializationName, and specialization
// ✅ Two-branch match:
// - If selectedDepartment is set → exact match against departmentName / specializationName
// - If coming from URL param (specialization) → match against pre-computed slugDepartment
const matchesSpeciality =
  speciality === "" ||
  (selectedDepartment
    ? // Dropdown selection: exact case-insensitive match on name fields
      doc.departmentName?.trim().toLowerCase() === speciality.trim().toLowerCase() ||
      doc.specializationName?.trim().toLowerCase() === speciality.trim().toLowerCase() ||
      doc.specialization?.trim().toLowerCase() === speciality.trim().toLowerCase()
    : // URL param: match against the pre-slugified field
      doc.slugDepartment === speciality.trim().toLowerCase()
  );



      const matchesFee =
        fees.length === 0 ||
        fees.some((feeRange) => {
          const [minStr, maxStr] = feeRange.split("-");
          const min = Number(minStr);
          const max = maxStr ? Number(maxStr) : Infinity;
          return doc.doctorFees >= min && doc.doctorFees <= max;
        });

      const matchesExperience =
        experiences.length === 0 ||
        experiences.some((expRange) => {
          const [minStr, maxStr] = expRange.split("-");
          const min = Number(minStr);
          const max = maxStr ? Number(maxStr) : Infinity;
          return doc.experienceYears >= min && doc.experienceYears <= max;
        });

      return (
        matchesLocation &&
        matchesName &&
        matchesSpeciality &&
        matchesGender &&
        // matchesFee &&
        matchesExperience &&
        matchesLanguages
      );
    });

    setFilteredDoctors(filtered);
  };

  const toggleExperience = (item: string) => {
    const updated = selectedExperiences.includes(item)
      ? selectedExperiences.filter((exp) => exp !== item)
      : [...selectedExperiences, item];
    setSelectedExperiences(updated);
    applyFilters({ locations: selectedLocations, fees: selectedFees, experiences: updated });
  };

  const toggleSelection = (item: string, type: "location" | "fee") => {
    if (type === "location") {
      const updated = selectedLocations.includes(item)
        ? selectedLocations.filter((loc) => loc !== item)
        : [...selectedLocations, item];
      setSelectedLocations(updated);
      applyFilters({ locations: updated, fees: selectedFees });
    } else {
      const updated = selectedFees.includes(item)
        ? selectedFees.filter((fee) => fee !== item)
        : [...selectedFees, item];
      setSelectedFees(updated);
      applyFilters({ locations: selectedLocations, fees: updated });
    }
  };

  const toggleLanguage = (language: string) => {
    const updated = selectedLanguages.includes(language)
      ? selectedLanguages.filter((lang) => lang !== language)
      : [...selectedLanguages, language];
    setSelectedLanguages(updated);
    applyFilters({ locations: selectedLocations, fees: selectedFees, languages: updated });
  };

  const clearAll = () => {
    setSelectedLocations([]);
    // setSelectedFees([]);
    setSelectedDepartment("");
    setSelectedGenders([]);
    setSelectedExperiences([]);
    setSelectedLanguages([]);
    setSearchTerm("");
    setFilters({ speciality: "" });
    setFilteredDoctors(allDoctors);
    //  localStorage.removeItem(SPECIALIZATION_STORAGE_KEY);
    navigate("/doctors");
  };

  // ─── JSX ──────────────────────────────────────────────────────────────────
  return (
    <div className="w-full bg-gray-200">
      {/* ── Filter Bar ── */}
      <div className="sticky top-[68px] lg:top-[71px] z-10 bg-white px-2 py-3 lg:px-5 lg:py-3 flex gap-2 lg:gap-4 shadow-sm
        overflow-x-auto whitespace-nowrap scrollbar-hide custom-scrollbar
        lg:flex-wrap lg:items-center lg:overflow-x-visible lg:whitespace-normal border-t border-gray-200">

        {/* Desktop Filters */}
        <div className="hidden lg:flex justify-start items-center gap-4 shadow-sm">

          {/* Speciality */}
          <div className="min-w-[130px]">
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-0"
              value={filters.speciality}
            onChange={(e) => {
  const value = e.target.value;
  setSelectedDepartment(value);
  setFilters({ speciality: value });

  const currentLocation = selectedLocations[0] || "";
  navigate(buildDoctorsUrl(currentLocation, value));
}}
            >
              <option value="">All Specialities</option>
              {specialities.map((s: any) => (
                <option key={s.DepartmentName} value={s.DepartmentName}>
                  {s.DepartmentName}
                </option>
              ))}
            </select>
          </div>

          {/* Location */}
          <div className="min-w-[180px]">
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-0"
              value={selectedLocations.length > 0 ? selectedLocations[0] : ""}
              onChange={(e) => {
  const value = e.target.value;
  const updated = value ? [value] : [];
  setSelectedLocations(updated);
  applyFilters({ locations: updated, fees: selectedFees });

  navigate(buildDoctorsUrl(value, selectedDepartment || filters.speciality));
}}
            >
              <option value="">All Locations</option>
              {locationsData.map((loc) => (
                <option key={loc.LocationId} value={loc.LocationName}>
                  {loc.LocationName}
                </option>
              ))}
            </select>
          </div>

          {/* Gender */}
          <div className="min-w-[110px]">
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-0"
              value={selectedGenders.length > 0 ? selectedGenders[0] : ""}
              onChange={(e) => {
                const value = e.target.value;
                const updated = value === "" ? [] : [value];
                setSelectedGenders(updated);
                applyFilters({ locations: selectedLocations, fees: selectedFees, genders: updated });
              }}
            >
              <option value="">All Genders</option>
              {gender.map((g) => (
                <option key={g} value={g}>
                  {g === "M" ? "Male" : "Female"}
                </option>
              ))}
            </select>
          </div>

          {/* Fees */}
          {/* <div className="min-w-[110px]">
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-0"
              value={selectedFees.length > 0 ? selectedFees[0] : ""}
              onChange={(e) => {
                const value = e.target.value;
                const updated = value === "" ? [] : [value];
                setSelectedFees(updated);
                applyFilters({ locations: selectedLocations, fees: updated });
              }}
            >
              <option value="">All Fees</option>
              {feeRanges.map((fee) => (
                <option key={fee.value} value={fee.value}>
                  {fee.label}
                </option>
              ))}
            </select>
          </div> */}

          {/* Experience */}
          <div className="min-w-[110px]">
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-0"
              value={selectedExperiences.length > 0 ? selectedExperiences[0] : ""}
              onChange={(e) => {
                const value = e.target.value;
                const updated = value === "" ? [] : [value];
                setSelectedExperiences(updated);
                applyFilters({ locations: selectedLocations, fees: selectedFees, experiences: updated });
              }}
            >
              <option value="">All Experience</option>
              {experienceRanges.map((exp) => (
                <option key={exp.value} value={exp.value}>
                  {exp.label}
                </option>
              ))}
            </select>
          </div>

          {/* Language */}
          <div className="min-w-[110px]">
            <select
              className="w-full border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-0"
              value={selectedLanguages.length > 0 ? selectedLanguages[0] : ""}
              onChange={(e) => {
                const value = e.target.value;
                const updated = value === "" ? [] : [value];
                setSelectedLanguages(updated);
                applyFilters({ locations: selectedLocations, fees: selectedFees, languages: updated });
              }}
            >
              <option value="">All Languages</option>
              {languagesData.map((lang) => (
                <option key={lang.LangId} value={lang.Name}>
                  {lang.Name}
                </option>
              ))}
            </select>
          </div>

          {/* Search by Name */}
          <div className="min-w-[200px] flex justify-center">
            <input
              type="text"
              placeholder="Search by Doctor Name"
              value={searchTerm}
              onChange={(e) => {
                const value = e.target.value;
                setSearchTerm(value);
                applyFilters({ locations: selectedLocations, fees: selectedFees, name: value });
              }}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-1 focus:ring-[#009A85]"
            />
          </div>

          {/* Clear All */}
          <div className="flex items-center">
            <button
              onClick={clearAll}
              className="group flex items-center gap-2 text-sm font-medium text-[#009A85] border-2 border-[#009A85]
                         px-5 py-2 rounded-xl hover:bg-[#009A85] hover:text-white hover:shadow-lg
                         transition-all duration-300 transform hover:scale-105 active:scale-95"
            >
              <svg className="w-4 h-4 transition-transform group-hover:rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Clear All
            </button>
          </div>
        </div>

        {/* Mobile Filter Button */}
        <div className="flex sticky  lg:hidden justify-end w-full">
          <button
            onClick={() => setShowMobileFilters(true)}
            className="flex items-center gap-2 px-4 py-1 border border-[#009A85] text-[#009A85] rounded-lg text-xs font-medium hover:bg-[#009A85] hover:text-white transition-all duration-200"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h18M4 9h16M6 14h12M10 19h4" />
            </svg>
            Filters
          </button>
        </div>
      </div>

      {/* ── Mobile Filters Drawer ── */}
    {/* ── Mobile Filters Drawer ── */}
{showMobileFilters && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex">
    <div className="w-full max-w-sm h-full bg-white shadow-xl p-4 overflow-y-auto flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-[#184A84]">Filters</h2>
        <button onClick={() => setShowMobileFilters(false)} className="text-gray-500 hover:text-gray-700 text-2xl p-1">×</button>
      </div>

      <div className="flex-1 space-y-6 overflow-y-auto custom-scrollbar">

        {/* Specialities — single select */}
        <section className="px-2">
          <h3 className="text-sm font-semibold text-gray-700 uppercase mb-2">Specialities</h3>
          <div className="space-y-3 max-h-[25vh] overflow-y-auto custom-scrollbar pr-2">
            <label className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
              <input
                type="radio"
                name="mobile-speciality"
                checked={filters.speciality === ""}
                onChange={() => {
                  setFilters({ speciality: "" });
                  setSelectedDepartment("");
                  navigate("/doctors");
                }}
                className="accent-[#009A85] mr-3 h-5 w-5"
              />
              All Specialities
            </label>
            {specialities.map((s: any) => (
              <label key={s.DepartmentName} className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
                <input
                  type="radio"
                  name="mobile-speciality"
                  checked={filters.speciality === s.DepartmentName}
                  onChange={() => {
                    setFilters({ speciality: s.DepartmentName });
                    setSelectedDepartment(s.DepartmentName);
                    navigate(`/doctors/${normalizeSlug(s.DepartmentName)}`);
                  }}
                  className="accent-[#009A85] mr-3 h-5 w-5"
                />
                {s.DepartmentName}
              </label>
            ))}
          </div>
        </section>

        {/* Locations — single select */}
        <section className="px-2">
          <h3 className="text-sm font-semibold text-gray-700 uppercase mb-2">Locations</h3>
          <div className="space-y-3">
            <label className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
              <input
                type="radio"
                name="mobile-location"
                checked={selectedLocations.length === 0}
                onChange={() => {
                  setSelectedLocations([]);
                  applyFilters({ locations: [], fees: selectedFees });
                }}
                className="accent-[#009A85] mr-3 h-5 w-5"
              />
              All Locations
            </label>
            {locationsData.map((loc) => (
              <label key={loc.LocationId} className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
                <input
                  type="radio"
                  name="mobile-location"
                  checked={selectedLocations.includes(loc.LocationName)}
                  onChange={() => {
                    const updated = [loc.LocationName];
                    setSelectedLocations(updated);
                    applyFilters({ locations: updated, fees: selectedFees });
                  }}
                  className="accent-[#009A85] mr-3 h-5 w-5"
                />
                {loc.LocationName}
              </label>
            ))}
          </div>
        </section>

        {/* Gender — single select */}
        <section className="px-2">
          <h3 className="text-sm font-semibold text-gray-700 uppercase mb-2">Gender</h3>
          <div className="space-y-3">
            <label className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
              <input
                type="radio"
                name="mobile-gender"
                checked={selectedGenders.length === 0}
                onChange={() => {
                  setSelectedGenders([]);
                  applyFilters({ locations: selectedLocations, fees: selectedFees, genders: [] });
                }}
                className="accent-[#009A85] mr-3 h-5 w-5"
              />
              All Genders
            </label>
            {gender.map((g) => (
              <label key={g} className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
                <input
                  type="radio"
                  name="mobile-gender"
                  checked={selectedGenders.includes(g)}
                  onChange={() => {
                    const updated = [g];
                    setSelectedGenders(updated);
                    applyFilters({ locations: selectedLocations, fees: selectedFees, genders: updated });
                  }}
                  className="accent-[#009A85] mr-3 h-5 w-5"
                />
                {g === "M" ? "Male" : "Female"}
              </label>
            ))}
          </div>
        </section>

        {/* Experience — single select */}
        <section className="px-2">
          <h3 className="text-sm font-semibold text-gray-700 uppercase mb-2">Experience</h3>
          <div className="space-y-3">
            <label className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
              <input
                type="radio"
                name="mobile-experience"
                checked={selectedExperiences.length === 0}
                onChange={() => {
                  setSelectedExperiences([]);
                  applyFilters({ locations: selectedLocations, fees: selectedFees, experiences: [] });
                }}
                className="accent-[#009A85] mr-3 h-5 w-5"
              />
              All Experience
            </label>
            {experienceRanges.map((exp) => (
              <label key={exp.value} className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
                <input
                  type="radio"
                  name="mobile-experience"
                  checked={selectedExperiences.includes(exp.value)}
                  onChange={() => {
                    const updated = [exp.value];
                    setSelectedExperiences(updated);
                    applyFilters({ locations: selectedLocations, fees: selectedFees, experiences: updated });
                  }}
                  className="accent-[#009A85] mr-3 h-5 w-5"
                />
                {exp.label}
              </label>
            ))}
          </div>
        </section>

        {/* Languages — single select */}
        <section className="px-2 mb-4">
          <h3 className="text-sm font-semibold text-gray-700 uppercase mb-2">Languages</h3>
          <div className="space-y-3 max-h-[25vh] overflow-y-auto custom-scrollbar pr-2">
            <label className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
              <input
                type="radio"
                name="mobile-language"
                checked={selectedLanguages.length === 0}
                onChange={() => {
                  setSelectedLanguages([]);
                  applyFilters({ locations: selectedLocations, fees: selectedFees, languages: [] });
                }}
                className="accent-[#009A85] mr-3 h-5 w-5"
              />
              All Languages
            </label>
            {languagesData.map((lang) => (
              <label key={lang.LangId} className="flex items-center text-sm text-gray-800 hover:text-[#009A85] transition-colors">
                <input
                  type="radio"
                  name="mobile-language"
                  checked={selectedLanguages.includes(lang.Name)}
                  onChange={() => {
                    const updated = [lang.Name];
                    setSelectedLanguages(updated);
                    applyFilters({ locations: selectedLocations, fees: selectedFees, languages: updated });
                  }}
                  className="accent-[#009A85] mr-3 h-5 w-5"
                />
                {lang.Name}
              </label>
            ))}
          </div>
        </section>
      </div>

      <div className="flex gap-3 mt-auto pt-4">
        <button
          onClick={() => { clearAll(); setShowMobileFilters(false); }}
          className="flex-1 border border-[#009A85] text-[#009A85] py-3 rounded-lg text-sm hover:bg-[#009A85] hover:text-white transition-colors"
        >
          Clear All
        </button>
        <button
          onClick={() => setShowMobileFilters(false)}
          className="flex-1 bg-[#009A85] text-white py-3 rounded-lg text-sm hover:bg-[#007365] transition-colors"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
)}


      {/* ── Doctor List ── */}
      <div className="flex justify-center  w-full">
        <div className="flex flex-col md:flex-row gap-2 w-[95%] sm:w-[90%] lg:w-[95%]">
          <div style={{ padding: "0px", display: "flex", width: "100%" }}>
            <MainContainer>
              <SubContainer>
                {isLoading ? (
                  <div className="relative w-full h-[200px] flex justify-center items-center py-10">
                    <div className="absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 loader"></div>
                  </div>
                ) : filteredDoctors?.length > 0 ? (
                  <>
                    {/* ── Mobile Cards ── */}
                    <div className="flex flex-col sm:hidden">
                      {filteredDoctors
                        .slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage)
                        .map((item: any, index: number) => {
                          const doctorLocations = getDoctorLocations(item);
                          const selectedLocation = doctorSelectedLocations[item.doctorId] || doctorLocations[0];
                          return (
                            <Paper elevation={5} key={index}>
                              <div className="bg-white rounded-lg p-2 shadow-md transition-shadow duration-300 ease-in-out my-1 hover:shadow-lg">
                                <div className="flex flex-col">
                                  <div className="flex items-center gap-3 mb-3">
                                    <div className="flex-shrink-0">
                                      <div
                                        onClick={() => handleCardClick(item.doctorId, {
                                          doctorData: {
                                            doctorId: item.doctorId,
                                            doctorName: item.doctorName,
                                            namePrefixCode: item.namePrefixCode,
                                            speciality: item.specializationName || item.specialization,
                                            location: selectedLocation?.locationName,
                                            avlDays: getAvailableDays(item.doctorId).availableDays,
                                            startDate: getAvailableDays(item.doctorId).startDate,
                                            endDate: getAvailableDays(item.doctorId).endDate,
                                            isOpen: showSlotsDrawer,
                                            selectedDoctor,
                                          },
                                        })}
                                        className="h-[105px] w-[90px] rounded-xl overflow-hidden flex justify-center items-center border border-[#184A84] hover:border-[#009A85] cursor-pointer shadow-md hover:shadow-xl transition-all duration-300 bg-white"
                                      >
                                        <img
                                          src={item.doctorImage ? `${process.env.REACT_APP_BASE_URL}/${item.doctorImage}` : Doctor}
                                          alt="Doctor"
                                          className="h-full w-full object-cover transition-transform duration-300"
                                        />
                                      </div>
                                    </div>

                                    <div className="flex-1 min-w-0">
                                      <div
                                        className="capitalize text-[15px] font-semibold cursor-pointer hover:text-[#009A85] truncate"
                                        onClick={() => handleCardClick(item.doctorId, {
                                          doctorData: {
                                            doctorId: item.doctorId,
                                            doctorName: item.doctorName,
                                            namePrefixCode: item.namePrefixCode,
                                            speciality: item.specializationName || item.specialization,
                                            location: selectedLocation?.locationName,
                                            avlDays: getAvailableDays(item.doctorId).availableDays,
                                            startDate: getAvailableDays(item.doctorId).startDate,
                                            endDate: getAvailableDays(item.doctorId).endDate,
                                            isOpen: showSlotsDrawer,
                                            selectedDoctor,
                                          },
                                        })}
                                      >
                                        {toTitleCase(item.doctorName)}
                                      </div>
                                      <div className="text-[12px] text-gray-800 mb-1">
                                        {item.specializationName || item.specialization}
                                      </div>
                                      <div className="text-[11px] text-[#184A84] mb-1 line-clamp-1">
                                        {item.qualification?.split(";").map((q: any) => q.trim()).filter(Boolean).map((q: any, i: any) => (
                                          <div key={i}>{q}</div>
                                        )) || <span className="text-sm">No qualifications listed</span>}
                                      </div>
                                      <div className="border border-[#009A85] px-2 py-1 rounded text-[#009A85] text-[10px] w-fit">
                                        {`${item.experienceYears}+ Years Exp`}
                                      </div>
                                      {item.languages && (
                                        <div className="text-[12px]">
                                          <span className="font-semibold text-gray-700">Languages: </span>
                                          <span className="text-gray-800">{item.languages}</span>
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* Mobile Location Selector */}
                                  <div className="flex flex-col gap-2 mb-3">
                                    <h4 className="text-[12px] font-semibold text-gray-700">Choose your preferred hospital location:</h4>
                                    {doctorLocations.map((loc, idx) => (
                                      <label
                                        key={idx}
                                        className={`flex flex-row items-center gap-3 max-w-md w-fit rounded-lg border px-3 py-0.5 cursor-pointer transition-all ${
                                          selectedLocation?.locationId === loc.locationId
                                            ? "border-[#184A84] bg-[#184A84]/5 text-[#184A84]"
                                            : "border-[#0099A8] hover:border-[#184A84]/75 text-[#0099A8]"
                                        }`}
                                        onClick={() => handleLocationSelect(item.doctorId, loc)}
                                      >
                                        <input type="radio" name={`location-mobile-${item.doctorId}`} checked={selectedLocation?.locationId === loc.locationId} onChange={() => handleLocationSelect(item.doctorId, loc)} className="sr-only" />
                                        <div className={`flex items-center gap-2 text-xs flex-1 transition-colors ${selectedLocation?.locationId === loc.locationId ? "text-[#184A84]" : "text-[#0099A8]"}`}>
                                          <div className={`w-3 h-3 rounded-full border flex items-center justify-center flex-shrink-0 transition-colors ${selectedLocation?.locationId === loc.locationId ? "border-[#184A84]" : "border-[#0099A8]"}`}>
                                            {selectedLocation?.locationId === loc.locationId && <div className="w-1.5 h-1.5 rounded-full bg-[#184A84]" />}
                                          </div>
                                          <span className="leading-snug truncate">{loc.hospitalName}, {loc.locationName}</span>
                                        </div>
                                        <div className="p-1 rounded-full bg-white shadow-sm">
                                          <FaMapMarkerAlt className="w-3 h-3 flex-shrink-0" />
                                        </div>
                                      </label>
                                    ))}
                                  </div>

                                  {/* Mobile Action Buttons */}
                                  <div className="pt-1 space-y-1">
                                    <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-lg p-3 border-l-4 border-[#009A85]">
                                      <div className="flex justify-between items-center">
                                        <div>
                                          <button
                                            onClick={() => handleCardClick(item.doctorId, {
                                              doctorData: {
                                                doctorId: item.doctorId,
                                                doctorName: item.doctorName,
                                                namePrefixCode: item.namePrefixCode,
                                                speciality: item.specializationName || item.specialization,
                                                location: selectedLocation?.locationName,
                                                avlDays: getAvailableDays(item.doctorId).availableDays,
                                                startDate: getAvailableDays(item.doctorId).startDate,
                                                endDate: getAvailableDays(item.doctorId).endDate,
                                                isOpen: showSlotsDrawer,
                                                selectedDoctor,
                                              },
                                            })}
                                            className="border border-[#184A84] text-[#184A84] font-semibold px-4 py-2.5 rounded-xl text-xs hover:bg-[#184A84] hover:text-white transform transition-all duration-200 hover:scale-105 active:scale-95"
                                          >
                                            View Profile
                                          </button>
                                        </div>
                                        <div className="ml-3 relative">
                                          <button
                                            onClick={() => handleBookAppointment(item.doctorId)}
                                            className="group relative bg-gradient-to-r from-[#009A85] to-[#007A6C] hover:from-[#007A6C] hover:to-[#006B5B] text-white font-semibold px-4 py-2.5 rounded-xl transform transition-all duration-200 hover:scale-105 active:scale-95 flex items-center gap-2 min-w-[110px] justify-center"
                                          >
                                            <svg className="w-4 h-4 group-hover:rotate-12 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            <span className="text-[12px]">Book Appointment</span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Paper>
                          );
                        })}
                    </div>

                    {/* ── Desktop Grid ── */}
                    <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-5">
                      {filteredDoctors
                        .slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage)
                        .map((item: any, index: number) => {
                          const doctorLocations = getDoctorLocations(item);
                          const selectedLocation = doctorSelectedLocations[item.doctorId] || doctorLocations[0];
                          return (
                            <div key={index} className="bg-white rounded-xl p-3 shadow-md transition-shadow duration-300 ease-in-out hover:shadow-xl h-fit flex flex-col">
                              <div className="flex gap-3 flex-grow">
                                <div className="flex-shrink-0">
                                  <div
                                    onClick={() => handleCardClick(item.doctorId, {
                                      doctorData: {
                                        doctorId: item.doctorId,
                                        doctorName: item.doctorName,
                                        namePrefixCode: item.namePrefixCode,
                                        speciality: item.specializationName || item.specialization,
                                        location: selectedLocation?.locationName,
                                        avlDays: getAvailableDays(item.doctorId).availableDays,
                                        startDate: getAvailableDays(item.doctorId).startDate,
                                        endDate: getAvailableDays(item.doctorId).endDate,
                                        isOpen: showSlotsDrawer,
                                        selectedDoctor,
                                      },
                                    })}
                                    className="w-23 h-28 rounded-xl overflow-hidden flex justify-center items-center border border-[#184A84] hover:border-[#009A85] cursor-pointer shadow-md hover:shadow-xl transition-all duration-300 bg-white"
                                  >
                                    <img
                                      src={item.doctorImage ? `${process.env.REACT_APP_BASE_URL}/${item.doctorImage}` : Doctor}
                                      alt="Doctor"
                                      className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
                                    />
                                  </div>
                                </div>

                                <div className="flex flex-col gap-1.5 min-w-0 max-w-[calc(100%-12.25rem)]">
                                  <div
                                    className="capitalize text-sm font-bold cursor-pointer hover:text-[#009A85] truncate"
                                    onClick={() => handleCardClick(item.doctorId, {
                                      doctorData: {
                                        doctorId: item.doctorId,
                                        doctorName: item.doctorName,
                                        namePrefixCode: item.namePrefixCode,
                                        speciality: item.specializationName || item.specialization,
                                        location: selectedLocation?.locationName,
                                        avlDays: getAvailableDays(item.doctorId).availableDays,
                                        startDate: getAvailableDays(item.doctorId).startDate,
                                        endDate: getAvailableDays(item.doctorId).endDate,
                                        isOpen: showSlotsDrawer,
                                        selectedDoctor,
                                      },
                                    })}
                                  >
                                    {toTitleCase(item.doctorName)}
                                  </div>
                                  <div className="text-xs text-gray-800">{item.specializationName || item.specialization}</div>

                                  <div className="relative group">
                                    <div className="text-[12px] text-[#184A84] line-clamp-2 truncate">
                                      {item.qualification?.split(";").map((q: any) => q.trim()).filter(Boolean).join(", ") || <span>No qualifications</span>}
                                    </div>
                                    <div className="absolute left-0 top-full mt-2 hidden group-hover:block z-50 w-max max-w-xs">
                                      <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg relative">
                                        <div className="absolute left-4 bottom-full w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent border-b-gray-900"></div>
                                        <p className="leading-relaxed">
                                          {item.qualification?.split(";").map((q: any) => q.trim()).filter(Boolean).join(", ") || "No qualifications"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="flex items-center gap-2 flex-wrap">
                                    <div className="border border-[#009A85] px-2 py-0.5 rounded text-[#009A85] text-[10px] whitespace-nowrap">
                                      {`${item.experienceYears}+ Years`}
                                    </div>
                                  </div>

                                  {item.languages && (
                                    <div className="text-[12px]">
                                      <span className="font-semibold text-gray-700">Languages: </span>
                                      <span className="text-gray-800">{item.languages}</span>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Desktop Location Selector */}
                              <div className="flex flex-col gap-1.5 mt-2">
                                <h4 className="text-[12px] font-semibold text-gray-700">Choose your preferred hospital location:</h4>
                                <div className="flex flex-wrap gap-1">
                                  {doctorLocations.map((loc, idx) => (
                                    <label
                                      key={idx}
                                      className={`flex items-center w-fit gap-1.5 rounded-lg border px-2 py-1 cursor-pointer transition-all ${
                                        selectedLocation?.locationId === loc.locationId
                                          ? "border-[#184A84] bg-[#184A84]/5 text-[#184A84]"
                                          : "border-[#0099A8] hover:border-[#0099A8] text-[#0099A8]"
                                      }`}
                                      onClick={() => handleLocationSelect(item.doctorId, loc)}
                                    >
                                      <input type="radio" name={`location-${item.doctorId}`} checked={selectedLocation?.locationId === loc.locationId} onChange={() => handleLocationSelect(item.doctorId, loc)} className="sr-only" />
                                      <div className={`w-3 h-3 rounded-full border flex items-center justify-center flex-shrink-0 transition-colors ${selectedLocation?.locationId === loc.locationId ? "border-[#184A84]" : "border-[#0099A8]"}`}>
                                        {selectedLocation?.locationId === loc.locationId && <div className="w-1.5 h-1.5 rounded-full bg-[#184A84]" />}
                                      </div>
                                      <span className="text-xs leading-tight truncate flex-1 min-w-0">{loc.hospitalName}, {loc.locationName}</span>
                                      <FaMapMarkerAlt className="w-2.5 h-2.5 flex-shrink-0" />
                                    </label>
                                  ))}
                                </div>
                              </div>

                              {/* Desktop Action Buttons */}
                              <div className="flex justify-between gap-2 mt-3 pt-2 border-t border-gray-100 w-full">
                                <button
                                  onClick={() => handleCardClick(item.doctorId, {
                                    doctorData: {
                                      doctorId: item.doctorId,
                                      doctorName: item.doctorName,
                                      namePrefixCode: item.namePrefixCode,
                                      speciality: item.specializationName || item.specialization,
                                      location: selectedLocation?.locationName,
                                      avlDays: getAvailableDays(item.doctorId).availableDays,
                                      startDate: getAvailableDays(item.doctorId).startDate,
                                      endDate: getAvailableDays(item.doctorId).endDate,
                                      isOpen: showSlotsDrawer,
                                      selectedDoctor,
                                    },
                                  })}
                                  className="border border-[#184A84] text-[#184A84] font-semibold px-3 py-1.5 rounded-lg text-xs hover:bg-[#184A84] hover:text-white transform transition-all duration-200 hover:scale-105 active:scale-95"
                                >
                                  View Profile
                                </button>
                                <button
                                  onClick={() => handleBookAppointment(item.doctorId)}
                                  className="bg-gradient-to-r from-[#009A85] to-[#007A6C] hover:from-[#007A6C] hover:to-[#006B5B] text-white font-semibold px-3 py-1.5 rounded-lg text-xs transform transition-all duration-200 hover:scale-105 active:scale-95 flex items-center justify-center gap-1"
                                >
                                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                  </svg>
                                  Book Appointment
                                </button>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </>
                ) : (
                  <NoDoctorsContactForm selectedLocations={selectedLocations} filters={filters}  locationId={selectedLocationId} />
                )}
                <div className="flex items-center justify-center my-8 px-4">
             

                  <nav className="flex items-center space-x-2 bg-white rounded-lg shadow-sm border border-gray-200 p-1">
                    <button
                      className={`flex items-center px-3 py-1 text-sm font-medium rounded-md transition-all duration-200 ${currentPage === 1 ? "text-gray-400 cursor-not-allowed bg-gray-50" : "text-gray-700 hover:bg-blue-50 hover:text-blue-600 hover:shadow-sm active:scale-95"}`}
                      onClick={() => goToPage(1)}
                      disabled={currentPage === 1}
                    >
                      <span className="hidden sm:inline">First</span>
                      <span className="sm:hidden">«</span>
                    </button>
                    <button
                      className={`flex items-center justify-center p-1 rounded-md transition-all duration-200 ${currentPage === 1 ? "text-gray-400 cursor-not-allowed" : "text-gray-600 hover:bg-blue-50 hover:text-blue-600 hover:shadow-sm active:scale-95"}`}
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <MdKeyboardArrowLeft className="w-5 h-5" />
                    </button>
                    <div className="flex items-center space-x-1">
                      {getPageNumbers().map((page) => (
                        <button
                          key={page}
                          onClick={() => goToPage(page)}
                          className={`min-w-[40px] h-5 px-2 text-sm font-medium rounded-md transition-all duration-200 ${page === currentPage ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 transform scale-105" : "text-gray-700 hover:bg-blue-50 hover:text-blue-600 hover:shadow-sm active:scale-95"}`}
                        >
                          {page}
                        </button>
                      ))}
                    </div>
                    <button
                      className={`flex items-center justify-center p-1 rounded-md transition-all duration-200 ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed" : "text-gray-600 hover:bg-blue-50 hover:text-blue-600 hover:shadow-sm active:scale-95"}`}
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <MdKeyboardArrowRight className="w-5 h-5" />
                    </button>
                    <button
                      className={`flex items-center px-3 py-1 text-sm font-medium rounded-md transition-all duration-200 ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed bg-gray-50" : "text-gray-700 hover:bg-blue-50 hover:text-blue-600 hover:shadow-sm active:scale-95"}`}
                      onClick={() => goToPage(totalPages)}
                      disabled={currentPage === totalPages}
                    >
                      <span className="hidden sm:inline">Last</span>
                      <span className="sm:hidden">»</span>
                    </button>
                  </nav>
                     {!isLoading && (
  <div className="ml-4 
  flex flex-col sm:flex-row justify-between items-center  px-4 text-sm text-gray-600 bg-white rounded-lg shadow-sm border border-gray-200 py-2">
  
    
    {/* Page range */}
    <div className="text-sm">
      Page <span className="font-semibold">{currentPage}</span> of <span className="font-semibold">{totalPages}&nbsp;</span> 
      ({startResult}-{endResult} of {totalResults})
    </div>
  </div>
)}
                </div>

                {/* ── Slots Drawer ── */}
                {showSlotsDrawer && selectedDoctor && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
                    <div className="relative bg-white rounded-lg shadow-xl w-[380px] xs:w-[400px] sm:w-[400px] md:w-[400px] lg:w-[470px] xl:w-[450px] min-h-[480px] overflow-y-auto">
                      <button
                        onClick={() => setShowSlotsDrawer(false)}
                        className="absolute top-4 right-4 z-10 text-gray-500 hover:text-gray-700 bg-white rounded-full p-2 shadow-md hover:shadow-lg transition-all duration-200"
                      >
                        <RxCross2 className="w-6 h-6" />
                      </button>
                      <div>
                        <DoctorAppointmentSlots
                          doctor={selectedDoctor}
                          selectedHospitalLocation={doctorSelectedLocations[selectedDoctor]}
                          onclose={() => setShowSlotsDrawer(false)}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </SubContainer>
            </MainContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
